import { QueryKey } from '../../enums/QueryKey';
import { getScenarioBudgetAdjustment } from '../../services/budgetScenarioBudgetAdjustmentValues';
import { createScenarioQuery } from './budgetScenarios';

export const useScenarioBudgetAdjustment = createScenarioQuery(
    QueryKey.BudgetScenarioBudgetAdjustment,
    getScenarioBudgetAdjustment
);
